<template>
  <div class="template">
    <Header />
    <div class="content">
      <Sidebar />
      <div class="container">
        <router-view />
      </div>
    </div>
    <Modal :show="exit" @closed="setExit(null)" :width="30" >
      <div class="rows">
        <div class="remove" v-if="exit">
          Вы действительно хотите выйти?
        </div>
        <div class="buttons">
          <Button label="Выйти" @click="logOut" />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Sidebar from '@/components/Sidebar'
import Modal from '@/components/Modal'
import Button from '@/components/ui/Button'

import { mapState, mapActions } from 'vuex'

export default {
  components: {
    Header,
    Sidebar,
    Modal,
    Button
  },
  computed: {
    ...mapState([
      'exit'
    ]),
  },
  methods: {
    ...mapActions([
      'setExit',
      'logOut'
    ])
  }
}
</script>

<style lang="scss" scoped>
.template{
  @include box(100%, 100%, absolute, 0, 0, null, null, 0, null);
  .content{
    @include box(100%, calc(100% - 3vw), absolute, 0, 3vw, null, null, 0, null);
    @include flex(left, top, row);
    .container{
      @include box(85%, 100%, relative, null, null, null, null, null, $body);
    }
  }
  .remove{
    @include text(0.9vw, 400, 0.05vw, null, left, $modalText);
    span{
      @include text(null, 500, null, null, null, null);
    }
  }
  .rows{
    @include box(100%, auto, relative, null, null, null, null, null, null);
    @include flex(left, top, row);
    flex-wrap: wrap;
    @include padding(0, 1vw, 0, 0);
  }
  .buttons{
    @include box(100%, auto, relative, null, null, null, null, null, null);
    @include flex(right, top, row);
    @include padding(0, 2vw, 0, 0);
    .button{
      @include size(10vw, null)
    }
  }
}
</style>
